/*
 * @Author:
 * @LastEditTime: 2023-04-20 10:54:32
 * @Description:
 */
import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'

export default class StdClassTypeService {
  static async detail(payload) {
    RecordOperation({ type: 'detail' })
    const [err, res] = await To(wizStandardInstance.get(`​/api/std/StdClassType/${payload.id}`))
    return Callback(err, res)
  }
  static async list(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassType?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async stdList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassType?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async create(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClassType', payload))
    return Callback(err, res)
  }
  static async update(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdClassType', payload))
    return Callback(err, res)
  }
  static async remove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(wizStandardInstance.delete('/api/std/StdClassType', payload))
    return Callback(err, res)
  }
  static async upload(payload) {
    RecordOperation({ type: 'import' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClassType/import', payload))
    return Callback(err, res)
  }
  static async exportFile(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClassType/export', payload))
    return Callback(err, res)
  }
  static async downloadTemplate(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClassType/download', payload))
    return Callback(err, res)
  }
  static async updateApproveStatus(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/update_approve_status?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getGeneralId(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassType/general_properties_class?classTypeId=${payload.id}`
      )
    )
    return Callback(err, res)
  }
}
